exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.typeInfo[data-v-554083c7] {\n  background: #F6F6F6;\n  border-radius: 0.2rem;\n  padding: 0.3rem 0.4rem;\n  margin-bottom: 0.6rem;\n}", ""]);

// exports
